module.exports = {
  API_URL: 'https://1407-backend.siteloft.pr.rexlabs.io/api/v1',
  WP_URL: 'https://1407-wordpress.siteloft.pr.rexlabs.io',
  ADMIN_URL: 'https://1407-backend.siteloft.pr.rexlabs.io/admin',
  // Storybook's /dev/component-preview is website-scoped, so this must point at
  // a real seeded site host (one routed by deploy/k8/pr_routes.yml), not the
  // bare backend host. Uses the byron seeded website (WebsiteTableSeeder).
  WEBSITE_PREVIEW_BASE_URL:
    'https://1407-45133267-3386-38a7-9e91-dbae3abcfc3b-backend.siteloft.pr.rexlabs.io'
};
